module.exports = __webpack_public_path__ + "static/media/img04.7f93713a.png";